import type { LabelHTMLAttributes } from 'react';
import { cn } from '../utils/cn';

type FormLabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export function FormLabel({ className, ...rest }: FormLabelProps) {
  return (
    <label
      className={cn('block text-sm font-medium text-hilevel-slate mb-1.5', className)}
      {...rest}
    />
  );
}
